import { computed } from 'mobx';

export default class ImageTagModel {
  id;
  store;

  constructor(store, tag) {
    this.store = store;
    this.id = +tag.id;
    this.name = tag.name;
    this.description = tag.description;
    this.images = tag.images;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
      images: this.images,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.description = json.description;
    this.images = json.images;
  }
}



// WEBPACK FOOTER //
// ./src/models/IDaq/ImageTagModel.js